const decodeHtmlEntitiesWithDom = (value) => {
  if (typeof document === 'undefined' || typeof document.createElement !== 'function') {
    return value;
  }

  const decoder = document.createElement('textarea');
  decoder.innerHTML = value;

  return decoder.value;
};

const decodeHtmlEntitiesWithFallback = (value) => {
  const entityMap = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&apos;': '\'',
    '&#39;': '\'',
    '&nbsp;': ' ',
  };

  return value
    .replace(/&(amp|lt|gt|quot|apos|nbsp|#39);/gi, (entity) => entityMap[entity.toLowerCase()] || entity)
    .replace(/&#(\d+);/g, (entity, code) => {
      const codePoint = Number.parseInt(code, 10);
      return Number.isNaN(codePoint) ? entity : String.fromCodePoint(codePoint);
    })
    .replace(/&#x([0-9a-f]+);/gi, (entity, code) => {
      const codePoint = Number.parseInt(code, 16);
      return Number.isNaN(codePoint) ? entity : String.fromCodePoint(codePoint);
    });
};

const decodeHtmlEntitiesOnce = (value) => {
  const domDecoded = decodeHtmlEntitiesWithDom(value);
  if (domDecoded !== value) {
    return domDecoded;
  }

  return decodeHtmlEntitiesWithFallback(value);
};

const decodeHtmlEntities = (value) => {
  if (typeof value !== 'string') return '';

  let output = value;

  for (let index = 0; index < 4; index += 1) {
    const decoded = decodeHtmlEntitiesOnce(output);
    if (decoded === output) break;
    output = decoded;
  }

  return output;
};

const getTechnicalReportText = (value) => {
  const decodedValue = decodeHtmlEntities(value == null ? '' : String(value)).trim();

  return decodedValue.length > 0 ? decodedValue : 'N/D';
};

export {
  decodeHtmlEntities,
  getTechnicalReportText,
};
